import React, { memo, forwardRef } from "react";
const SvgDecimal = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.136 22.04c0 .277-.101.523-.304.736-.203.213-.459.32-.768.32-.299 0-.555-.101-.768-.304a1.038 1.038 0 01-.304-.736c0-.288.101-.533.304-.736.203-.213.459-.32.768-.32.31 0 .566.101.768.304.203.203.304.448.304.736z"
      />
    </svg>
  );
});
SvgDecimal.displayName = "SvgDecimal";
const MemoForwardRef = memo(SvgDecimal);
export default MemoForwardRef;
